function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { worldViewerWindow } from '../../const';
import { CAchievementApiNotification } from './CAchievementApiNotification';
export class CAchievement {
    addReceivedToastEventListener(fn) {
        var _this_m_AchievementApiNotification;
        (_this_m_AchievementApiNotification = this.m_AchievementApiNotification) === null || _this_m_AchievementApiNotification === void 0 ? void 0 : _this_m_AchievementApiNotification.addPersonalEvent(fn);
    }
    async receive(params) {
        const { data: { achievement  }  } = await worldViewerWindow.heliport.v3.api.achievement.fetchAchievementInformation({
            label: params.ReferenceID
        });
        const isLangJa = worldViewerWindow.hel_isLangJa();
        let achievementName = isLangJa ? achievement.title : achievement.title_en;
        if (achievementName.length > 15) {
            achievementName = achievementName.substring(0, 15) + '...';
        }
        // TODO: 英語の通知
        const message = isLangJa ? `アチーブメント「${achievementName}」を獲得しました！` : `アチーブメント「${achievementName}」を獲得しました！`;
        worldViewerWindow.hel_toast_notify_message(message, 250, 8000, 250);
    }
    // コンストラクタ
    constructor(){
        _defineProperty(this, "m_AchievementApiNotification", null);
        this.m_AchievementApiNotification = new CAchievementApiNotification();
    }
}
